import Article from '../../pages/Article/ Article'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_app/articles_/$articleId')({
  component: Article,
})
